import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    url: String,
  };

  static targets = ['loading', 'error'];

  connect() {
    this.boundHandleUpdate = this.handleProgramsUpdate.bind(this);
    this.abortController = null;

    document.addEventListener(
      'promote:dashboard:programs-updated',
      this.boundHandleUpdate
    );
  }

  disconnect() {
    document.removeEventListener(
      'promote:dashboard:programs-updated',
      this.boundHandleUpdate
    );

    if (this.abortController) {
      this.abortController.abort();
    }
  }

  handleProgramsUpdate(event) {
    const { programIds } = event.detail;
    this.fetchData(programIds);
  }

  fetchData(programIds) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    this.showLoading();

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.urlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({ program_ids: programIds }),
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then((data) => this.renderData(data))
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.showError();
      });
  }

  // Override this method in child controllers
  renderData(data) {
    this.hideLoading();
    this.hideError();
  }

  formatNumber(num) {
    return new Intl.NumberFormat().format(num);
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('hidden');
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('hidden');
    }
  }

  showError() {
    this.hideLoading();
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('hidden');
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
    }
  }
}
